<!-- find name in https://tabler.io/icons -->

<i-tabler [name]="iconName" [class]="iconClass" [ngStyle]="styleMap">
</i-tabler>